import type { Dayjs } from 'dayjs';
import type { RoutineActivity } from '@demind-inc/core';

import { isDateEnabledForRecurring } from '../components/Scheduler/AIScheduler/reducer/routinePrefItem.state';
import { findWorkoutRoutineActivity } from './allPlanSuggestions.helpers';

/** Whether workout planning should be selected by default for the given day (matches lifestack_calendar). */
export const isWorkoutEnabledForDate = (
  activities: RoutineActivity[] | null | undefined,
  date: Dayjs
): boolean => {
  const workoutActivity = findWorkoutRoutineActivity(activities);
  if (!workoutActivity || workoutActivity.hidden) {
    return false;
  }
  return isDateEnabledForRecurring(workoutActivity.recurring, date);
};
